import React from "react";

class SplitButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.wrapperRef = React.createRef();

        this.toggleMenu = this.toggleMenu.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
            this.setState({ open: false });
        }
    }

    toggleMenu() {
        this.setState((prev) => ({ open: !prev.open }));
    }

    render() {
        const {
            label,
            icon,
            color = "blue",
            textColor = "white",
            loading,
            onClick,
            className = "",
        } = this.props;

        return (
            <div className="relative inline-flex" ref={this.wrapperRef}>
                {/* Botão principal */}
                <button
                    type={this.props.type}
                    onClick={onClick}
                    disabled={loading}
                    className={`
                        h-9 px-3.5 bg-${color}-600
                        text-${textColor}
                        rounded-l-md shadow-xs
                        hover:bg-${color}-700
                        flex items-center gap-2 text-sm font-medium
                        transition-colors duration-150
                        disabled:bg-${color}-300 disabled:cursor-not-allowed text-nowrap
                        ${className}
                    `}
                >
                    {loading ? (
                        <i className="fas fa-spinner fa-spin"></i>
                    ) : (
                        icon && <i className={icon}></i>
                    )}

                    {label}
                </button>

                {/* Botão de dropdown */}
                <button
                    type="button"
                    onClick={this.toggleMenu}
                    disabled={loading}
                    className={`
                        h-9 px-2 bg-${color}-600
                        text-${textColor}
                        rounded-r-md shadow-xs border-l border-black/10
                        hover:bg-${color}-700
                        transition-colors duration-150
                        disabled:bg-${color}-300 disabled:cursor-not-allowed
                    `}
                >
                    <i className="fas fa-chevron-down"></i>
                </button>

                {/* Menu dropdown */}
                {this.state.open && (
                    <div
                        className="absolute right-0 top-full mt-2 surface-panel z-50 min-w-[150px] animate-in fade-in zoom-in-95 duration-150"
                    >
                        <ul className="py-1.5">
                            {this.props.items?.map((item, index) => (
                                <li key={index}>
                                    <button
                                        className="
                                            w-full text-left px-4 py-2
                                            hover:bg-muted text-sm text-foreground flex items-center gap-2 transition-colors
                                        "
                                        onClick={() => {
                                            this.setState({ open: false });
                                            item.onClick();
                                        }}
                                    >
                                        {item.icon && <i className={item.icon}></i>}
                                        {item.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default SplitButton;
